import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import WhyGoodEmployeesDontMakeTeam from './components/WhyGoodEmployeesDontMakeTeam';
import WhatIsTeamBuilding from './components/WhatIsTeamBuilding';
import ProblemsSolved from './components/ProblemsSolved';
import WhenToDevelop from './components/WhenToDevelop';
import WhyClassicTeamBuildingFails from './components/WhyClassicTeamBuildingFails';
import ModernMethods from './components/ModernMethods';
import BusinessGames from './components/BusinessGames';
import HowItGoes from './components/HowItGoes';
import CompanyResults from './components/CompanyResults';
import FormatsBySize from './components/FormatsBySize';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import ReadNextSection from './components/ReadNextSection';
import Footer from '@/components/feature/Footer';

const teamBuildingNavLinks = [
  { label: 'Что это', target: 'what-is' },
  { label: 'Проблемы', target: 'problems' },
  { label: 'Методы', target: 'methods' },
  { label: 'Процесс', target: 'process' },
  { label: 'FAQ', target: 'faq' },
];

export default function TeamBuildingPage() {


  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      
      <SeoTitle title="Командообразование | Business Training" />
      <PageJsonLd />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={teamBuildingNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <WhyGoodEmployeesDontMakeTeam />
        <WhatIsTeamBuilding />
        <ProblemsSolved />
        <WhenToDevelop />
        <WhyClassicTeamBuildingFails />
        <ModernMethods />
        <BusinessGames />
        <HowItGoes />
        <CompanyResults />
        <FormatsBySize />
        <WhyWorkWithMe />
        <CTASection />
        <FAQSection />
        <ReadNextSection />
        <Footer />
      </div>
    </>
  );
}